import { render, staticRenderFns } from "./MainFilters.vue?vue&type=template&id=12645e40&"
import script from "./MainFilters.vue?vue&type=script&lang=ts&"
export * from "./MainFilters.vue?vue&type=script&lang=ts&"
import style0 from "./MainFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports